import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { NumberedCard as Block } from "./NumberedCardBlock";
import { defaultData } from "./NumberedCardBlockDefaultData";
import imagePreview from "./numbered_card_preview.png";

export const NumberedCardBlock: BlockExport = {
  type: "component",
  Block,
  imagePreview: {
    type: "image-url",
    lg: imagePreview,
  },
  defaultData,
  meta: {
    name: "Numbered Card",
    version: 1,
    nameI18n: "builder_ui.block_type.numbered_card",
    isHidden: true,
    props: {
      number: {
        name: "Number",
        nameI18n: "builder_ui.prop_type.number",
        prop: "other",
        type: "string",
      },
      content: {
        name: "Content",
        nameI18n: "builder_ui.prop_type.content",
        prop: "children",
        type: "children",
        accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
      },
    },
  },
};
